import React from 'react';
import { useTranslation } from 'react-i18next';
import { ShieldOff } from 'lucide-react';

export type AccessDeniedReason = 'admin' | 'role' | 'permission';

/** Shown in place of a route the signed-in user may not open. */
const AccessDenied: React.FC<{ reason: AccessDeniedReason }> = ({ reason }) => {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-3 px-6 text-center">
      <span className="grid size-14 place-items-center rounded-2xl bg-muted text-muted-foreground">
        <ShieldOff className="size-7" strokeWidth={1.7} />
      </span>

      <h1 className="revy-cjk text-xl font-semibold leading-[1.5]">{t('errors.accessDenied')}</h1>

      <p className="revy-cjk max-w-md text-sm leading-[1.6] text-muted-foreground">
        {t(`errors.accessDeniedReason.${reason}`)}
      </p>

      <p className="revy-cjk max-w-md text-xs leading-[1.6] text-muted-foreground">
        {t('errors.accessDeniedContact')}
      </p>
    </div>
  );
};

export default AccessDenied;
